import React from 'react'
import PropTypes from 'prop-types'

import { WebinarInfoPanelComponent, If } from '../../../sharedLegacy/components'
import { WaitingRoomCountdownComponent, ThankYouMessageComponent } from '..'
import { useWebinarColors } from '../../../Designs/blocs/useWebinarColors'
import { useLiveDataQuery } from '../../../global/blocs/useLiveData'

import './SimpleWaitingRoomScreenComponent.scss'
import './SimpleWaitingRoomScreenComponent.mobile.scss'

const renderInfoPanel = (isMobileDevice) => (
  <WebinarInfoPanelComponent
    theme="waiting-room"
    speakersSize={isMobileDevice ? 'small' : 'large'}
    style={{ color: '#FFFFFF' }}
  />
)

const SimpleWaitingRoomScreenComponent = (props) => {
  const {
    webinarTimeEpoch,
    isWebinarTimeInThePast,
    onLiveCountdownZero,
    hasBeenBroadcasting,
    countdownEnabled,
    isWebinarOver,
    isMobileDevice,
  } = props

  const { data: liveData } = useLiveDataQuery()

  const webinarColors = useWebinarColors()

  return (
    <div className="simple-waiting-room-screen-component">
      <div className="waiting-room-content">
        <If condition={countdownEnabled && !isWebinarOver}>
          <WaitingRoomCountdownComponent
            webinarTimeEpoch={webinarTimeEpoch}
            isWebinarTimeInThePast={isWebinarTimeInThePast}
            isHolding={hasBeenBroadcasting}
            onLiveCountdownZero={onLiveCountdownZero}
          />
        </If>
        <If condition={!isWebinarOver || !liveData?.after_webinar_link}>
          <div
            className="decoration-line"
            style={{
              background: `linear-gradient(-90deg, rgb(30, 30, 30) 0%, ${webinarColors.accent} 100%)`,
            }}
          />
        </If>
        {isWebinarOver ? (
          <ThankYouMessageComponent />
        ) : (
          renderInfoPanel(isMobileDevice)
        )}
      </div>
    </div>
  )
}

SimpleWaitingRoomScreenComponent.propTypes = {
  webinarTimeEpoch: PropTypes.number,
  isWebinarTimeInThePast: PropTypes.bool,
  hasBeenBroadcasting: PropTypes.bool,
  countdownEnabled: PropTypes.bool,
  onLiveCountdownZero: PropTypes.func,
  isWebinarOver: PropTypes.bool,
  isMobileDevice: PropTypes.bool,
}

export default SimpleWaitingRoomScreenComponent
